import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { IconSanitizerService } from 'ngx-lib';

@Component({
    selector: 'app-welcome-screen',
    templateUrl: './welcome-screen.component.html',
    styleUrls: ['./welcome-screen.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class WelcomeScreenComponent implements OnInit {
    singInIcon: SafeHtml;
    loginSectionIcon: SafeHtml;

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.singInIcon = this.iconSanitizer.getIcon('singIn');
        this.loginSectionIcon = this.iconSanitizer.getIcon('loginSection');
    }

    ngOnInit(): void {
        this.authService.redirectIfAuthenticated();
    }

    redirectToLogin() {
        this.router.navigate(['/login']);
    }
}
